import type { BotState, FormState } from '../types';

export const handleCloudflareBotCheck = <T extends string>(
  promise: Promise<any>,
  setFormState: React.Dispatch<React.SetStateAction<FormState<T>>>,
  formSubmitted: boolean | undefined,
  formLoading: boolean | undefined,
  setBotState: React.Dispatch<React.SetStateAction<BotState>>,
  setIsRecaptchaRequired: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  promise
    .then((isBot) => {
      setBotState({ isBotCheckDone: true });
      if (isBot) {
        setIsRecaptchaRequired(true);
      }
    })
    .catch((error: T) => {
      setFormState({
        submitted: formSubmitted,
        loading: formLoading,
        error,
      });
    });
};
